import * as React from 'react'
import { IOWidget, Updater, any, async, fromJSX } from 'widgets-for-react'
import { KnowledgeTypeTeasersLayout } from './knowledgeTypeTeasersLayout'
import { KnowledgeTypeTeasersState } from './knowledgeTypeTeasersState'

export const knowledgeTypeTeasersWidget: IOWidget<
  KnowledgeTypeTeasersState,
  Updater<KnowledgeTypeTeasersState>
> = (knowledgeTypeTeasersState) =>
  any([
    async(knowledgeTypeTeasersState),
    fromJSX(() => (
      <KnowledgeTypeTeasersLayout
        knowledgeTypeTeasersState={knowledgeTypeTeasersState}
      />
    )),
  ])
